export type Destination = {
  name: string;
  km: number;
  country: 'AT' | 'DE' | 'CZ' | 'IT' | 'SI';
  flag: string;
  popular?: boolean;
};

export const countryLabels: Record<string, string> = {
  AT: '🇦🇹 Österreich',
  DE: '🇩🇪 Deutschland',
  CZ: '🇨🇿 Tschechien',
  IT: '🇮🇹 Italien',
  SI: '🇸🇮 Slowenien',
};

export const destinations: Destination[] = [
  // AUSTRIA
  { name: 'Abtenau', km: 40, country: 'AT', flag: '🇦🇹' },
  { name: 'Adnet', km: 15, country: 'AT', flag: '🇦🇹' },
  { name: 'Altenmarkt im Pongau', km: 65, country: 'AT', flag: '🇦🇹' },
  { name: 'Anif', km: 5, country: 'AT', flag: '🇦🇹' },
  { name: 'Annaberg-Lungötz', km: 55, country: 'AT', flag: '🇦🇹' },
  { name: 'Bad Gastein', km: 100, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Bad Hofgastein', km: 95, country: 'AT', flag: '🇦🇹' },
  { name: 'Bad Ischl', km: 50, country: 'AT', flag: '🇦🇹' },
  { name: 'Bad Vigaun', km: 20, country: 'AT', flag: '🇦🇹' },
  { name: 'Berndorf bei Salzburg', km: 25, country: 'AT', flag: '🇦🇹' },
  { name: 'Bischofshofen', km: 50, country: 'AT', flag: '🇦🇹' },
  { name: 'Bramberg am Wildkogel', km: 110, country: 'AT', flag: '🇦🇹' },
  { name: 'Bruck an der Großglocknerstraße', km: 95, country: 'AT', flag: '🇦🇹' },
  { name: 'Bürmoos', km: 25, country: 'AT', flag: '🇦🇹' },
  { name: 'Dienten am Hochkönig', km: 70, country: 'AT', flag: '🇦🇹' },
  { name: 'Dorfgastein', km: 85, country: 'AT', flag: '🇦🇹' },
  { name: 'Ebensee', km: 90, country: 'AT', flag: '🇦🇹' },
  { name: 'Eben im Pongau', km: 60, country: 'AT', flag: '🇦🇹' },
  { name: 'Elixhausen', km: 10, country: 'AT', flag: '🇦🇹' },
  { name: 'Ellmau', km: 130, country: 'AT', flag: '🇦🇹' },
  { name: 'Eugendorf', km: 10, country: 'AT', flag: '🇦🇹' },
  { name: 'Faistenau', km: 20, country: 'AT', flag: '🇦🇹' },
  { name: 'Filzmoos', km: 70, country: 'AT', flag: '🇦🇹' },
  { name: 'Flachau', km: 70, country: 'AT', flag: '🇦🇹' },
  { name: 'Forstau', km: 80, country: 'AT', flag: '🇦🇹' },
  { name: 'Fuschl am See', km: 20, country: 'AT', flag: '🇦🇹' },
  { name: 'Goldegg', km: 80, country: 'AT', flag: '🇦🇹' },
  { name: 'Golling an der Salzach', km: 30, country: 'AT', flag: '🇦🇹' },
  { name: 'Grödig', km: 10, country: 'AT', flag: '🇦🇹' },
  { name: 'Großarl', km: 75, country: 'AT', flag: '🇦🇹' },
  { name: 'Hallein', km: 15, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Hallstatt', km: 75, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Henndorf am Wallersee', km: 15, country: 'AT', flag: '🇦🇹' },
  { name: 'Hintersee', km: 25, country: 'AT', flag: '🇦🇹' },
  { name: 'Hof bei Salzburg', km: 15, country: 'AT', flag: '🇦🇹' },
  { name: 'Hollersbach im Pinzgau', km: 115, country: 'AT', flag: '🇦🇹' },
  { name: 'Hüttau', km: 55, country: 'AT', flag: '🇦🇹' },
  { name: 'Hüttschlag', km: 85, country: 'AT', flag: '🇦🇹' },
  { name: 'Innsbruck', km: 185, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Kaprun', km: 95, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Koppl', km: 15, country: 'AT', flag: '🇦🇹' },
  { name: 'Köstendorf', km: 25, country: 'AT', flag: '🇦🇹' },
  { name: 'Krimml', km: 125, country: 'AT', flag: '🇦🇹' },
  { name: 'Kuchl', km: 25, country: 'AT', flag: '🇦🇹' },
  { name: 'Lamprechtshausen', km: 25, country: 'AT', flag: '🇦🇹' },
  { name: 'Linz', km: 125, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Lofer', km: 45, country: 'AT', flag: '🇦🇹' },
  { name: 'Maria Alm', km: 85, country: 'AT', flag: '🇦🇹' },
  { name: 'Mariapfarr', km: 115, country: 'AT', flag: '🇦🇹' },
  { name: 'Mauterndorf', km: 110, country: 'AT', flag: '🇦🇹' },
  { name: 'Mayrhofen', km: 160, country: 'AT', flag: '🇦🇹' },
  { name: 'Mittersill', km: 115, country: 'AT', flag: '🇦🇹' },
  { name: 'Mondsee', km: 30, country: 'AT', flag: '🇦🇹' },
  { name: 'Muhr', km: 110, country: 'AT', flag: '🇦🇹' },
  { name: 'Neukirchen am Großvenediger', km: 120, country: 'AT', flag: '🇦🇹' },
  { name: 'Niedernsill', km: 100, country: 'AT', flag: '🇦🇹' },
  { name: 'Nußdorf am Haunsberg', km: 20, country: 'AT', flag: '🇦🇹' },
  { name: 'Oberalm', km: 15, country: 'AT', flag: '🇦🇹' },
  { name: 'Oberndorf bei Salzburg', km: 20, country: 'AT', flag: '🇦🇹' },
  { name: 'Obertrum am See', km: 20, country: 'AT', flag: '🇦🇹' },
  { name: 'Obertauern', km: 90, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Piesendorf', km: 95, country: 'AT', flag: '🇦🇹' },
  { name: 'Plainfeld', km: 15, country: 'AT', flag: '🇦🇹' },
  { name: 'Puch bei Hallein', km: 20, country: 'AT', flag: '🇦🇹' },
  { name: 'Radstadt', km: 75, country: 'AT', flag: '🇦🇹' },
  { name: 'Rauris', km: 100, country: 'AT', flag: '🇦🇹' },
  { name: 'Rußbach am Paß Gschütt', km: 50, country: 'AT', flag: '🇦🇹' },
  { name: 'Saalbach-Hinterglemm', km: 100, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Saalfelden', km: 70, country: 'AT', flag: '🇦🇹' },
  { name: 'Sankt Gilgen', km: 30, country: 'AT', flag: '🇦🇹' },
  { name: 'Sankt Johann im Pongau', km: 60, country: 'AT', flag: '🇦🇹' },
  { name: 'Sankt Koloman', km: 35, country: 'AT', flag: '🇦🇹' },
  { name: 'Sankt Martin bei Lofer', km: 50, country: 'AT', flag: '🇦🇹' },
  { name: 'Sankt Michael im Lungau', km: 115, country: 'AT', flag: '🇦🇹' },
  { name: 'Sankt Veit im Pongau', km: 70, country: 'AT', flag: '🇦🇹' },
  { name: 'Salzburg Airport (SZG)', km: 5, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Salzburg Hauptbahnhof', km: 2, country: 'AT', flag: '🇦🇹' },
  { name: 'Salzburg Altstadt', km: 0, country: 'AT', flag: '🇦🇹' },
  { name: 'Schladming', km: 95, country: 'AT', flag: '🇦🇹' },
  { name: 'Seeham', km: 25, country: 'AT', flag: '🇦🇹' },
  { name: 'Seekirchen am Wallersee', km: 15, country: 'AT', flag: '🇦🇹' },
  { name: 'Strobl', km: 40, country: 'AT', flag: '🇦🇹' },
  { name: 'St. Wolfgang im Salzkammergut', km: 45, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Tamsweg', km: 110, country: 'AT', flag: '🇦🇹' },
  { name: 'Taxenbach', km: 90, country: 'AT', flag: '🇦🇹' },
  { name: 'Thalgau', km: 20, country: 'AT', flag: '🇦🇹' },
  { name: 'Unken', km: 35, country: 'AT', flag: '🇦🇹' },
  { name: 'Uttendorf', km: 105, country: 'AT', flag: '🇦🇹' },
  { name: 'Vienna (Wien)', km: 300, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Vigaun', km: 20, country: 'AT', flag: '🇦🇹' },
  { name: 'Vöcklabruck', km: 70, country: 'AT', flag: '🇦🇹' },
  { name: 'Wagrain', km: 70, country: 'AT', flag: '🇦🇹' },
  { name: 'Wald im Pinzgau', km: 130, country: 'AT', flag: '🇦🇹' },
  { name: 'Wals-Siezenheim', km: 5, country: 'AT', flag: '🇦🇹' },
  { name: 'Werfen', km: 40, country: 'AT', flag: '🇦🇹' },
  { name: 'Werfenweng', km: 45, country: 'AT', flag: '🇦🇹' },
  { name: 'Wolfgangsee', km: 40, country: 'AT', flag: '🇦🇹' },
  { name: 'Zell am See', km: 85, country: 'AT', flag: '🇦🇹', popular: true },
  { name: 'Zell am Moos', km: 25, country: 'AT', flag: '🇦🇹' },

  // GERMANY
  { name: 'Ainring', km: 15, country: 'DE', flag: '🇩🇪' },
  { name: 'Augsburg', km: 230, country: 'DE', flag: '🇩🇪' },
  { name: 'Bad Reichenhall', km: 20, country: 'DE', flag: '🇩🇪' },
  { name: 'Bayerisch Gmain', km: 20, country: 'DE', flag: '🇩🇪' },
  { name: 'Berchtesgaden', km: 30, country: 'DE', flag: '🇩🇪', popular: true },
  { name: 'Bischofswiesen', km: 35, country: 'DE', flag: '🇩🇪' },
  { name: 'Chiemsee', km: 85, country: 'DE', flag: '🇩🇪' },
  { name: "Eagle's Nest (Kehlsteinhaus)", km: 35, country: 'DE', flag: '🇩🇪', popular: true },
  { name: 'Freilassing', km: 10, country: 'DE', flag: '🇩🇪' },
  { name: 'Garmisch-Partenkirchen', km: 200, country: 'DE', flag: '🇩🇪' },
  { name: 'Hintersee (DE)', km: 35, country: 'DE', flag: '🇩🇪' },
  { name: 'Inzell', km: 40, country: 'DE', flag: '🇩🇪' },
  { name: 'Königssee', km: 35, country: 'DE', flag: '🇩🇪', popular: true },
  { name: 'Laufen', km: 25, country: 'DE', flag: '🇩🇪' },
  { name: 'München (Munich)', km: 150, country: 'DE', flag: '🇩🇪', popular: true },
  { name: 'Passau', km: 120, country: 'DE', flag: '🇩🇪' },
  { name: 'Prien am Chiemsee', km: 90, country: 'DE', flag: '🇩🇪' },
  { name: 'Ramsau (DE)', km: 35, country: 'DE', flag: '🇩🇪' },
  { name: 'Reit im Winkl', km: 70, country: 'DE', flag: '🇩🇪' },
  { name: 'Rosenheim', km: 100, country: 'DE', flag: '🇩🇪' },
  { name: 'Ruhpolding', km: 55, country: 'DE', flag: '🇩🇪' },
  { name: 'Schönau am Königssee', km: 35, country: 'DE', flag: '🇩🇪' },
  { name: 'Tegernsee', km: 165, country: 'DE', flag: '🇩🇪' },
  { name: 'Teisendorf', km: 25, country: 'DE', flag: '🇩🇪' },
  { name: 'Tittmoning', km: 40, country: 'DE', flag: '🇩🇪' },
  { name: 'Traunstein', km: 85, country: 'DE', flag: '🇩🇪' },
  { name: 'Waging am See', km: 35, country: 'DE', flag: '🇩🇪' },
  { name: 'Zugspitze', km: 200, country: 'DE', flag: '🇩🇪' },

  // CZECH REPUBLIC
  { name: 'Český Krumlov', km: 205, country: 'CZ', flag: '🇨🇿', popular: true },
  { name: 'České Budějovice', km: 220, country: 'CZ', flag: '🇨🇿' },
  { name: 'Karlovy Vary', km: 250, country: 'CZ', flag: '🇨🇿' },
  { name: 'Praha (Prague)', km: 330, country: 'CZ', flag: '🇨🇿' },

  // ITALY
  { name: 'Bozen (Bolzano)', km: 330, country: 'IT', flag: '🇮🇹' },
  { name: 'Brixen', km: 280, country: 'IT', flag: '🇮🇹' },
  { name: 'Lago di Braies', km: 260, country: 'IT', flag: '🇮🇹' },
  { name: 'Meran', km: 330, country: 'IT', flag: '🇮🇹' },
  { name: 'Sterzing', km: 240, country: 'IT', flag: '🇮🇹' },

  // SLOVENIA
  { name: 'Bled', km: 290, country: 'SI', flag: '🇸🇮' },
  { name: 'Ljubljana', km: 320, country: 'SI', flag: '🇸🇮' },
];
